module.exports = __webpack_public_path__ + "static/media/4-2.9f90d145.mp3";